export function formatDateISO(date) {
  if (!(date instanceof Date) || isNaN(date)) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export function formatDateUK(date) {
  if (!(date instanceof Date) || isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
export function parseUKDate(dateStr) {
  if (!dateStr) return new Date(NaN);

  if (typeof dateStr !== 'string') {
    return new Date(dateStr);
  }

  const str = dateStr.trim();

  // ISO format (YYYY-MM-DD) from <input type="date">
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return new Date(`${str}T00:00:00`);
  }

  // dd/mm/yy or dd/mm/yyyy
  let match = str.match(/^(\d{2})\/(\d{2})\/(\d{2,4})$/);
  if (match) {
    let [, day, month, year] = match;
    if (year.length === 2) year = '20' + year;
    return new Date(`${year}-${month}-${day}T00:00:00`);
  }

  // ddmmyy or ddmmyyyy
  match = str.match(/^(\d{2})(\d{2})(\d{2,4})$/);
  if (match) {
    let [, day, month, year] = match;
    if (year.length === 2) year = '20' + year;
    return new Date(`${year}-${month}-${day}T00:00:00`);
  }

  // Invalid format
  return new Date(NaN);
}
export const meterTypeOptions = [
  { value: 1, label: 'AC Energy' },
  { value: 2, label: 'DC Energy' },
  { value: 3, label: 'AC & DC Energy' },
];

export function generateFileName(prefix = 'UI') {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${prefix}_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.csv`;
}

export const TYPE_LABELS = { 
  1: 'AC Energy', 
  2: 'DC Energy', 
  3: 'AC & DC Energy' 
};

export const labelForType = (v) => TYPE_LABELS?.[v] ?? v;

export const prettifyHeader = (h) =>
  /^[A-Z]+$/.test(h) ? h : h.replace(/([A-Z])/g, ' $1').trim();

export const issuesForHeader = (header, issues = []) => {
  const lower = header.toLowerCase();
  const pretty = prettifyHeader(header).toLowerCase();

  return issues.filter((issue) => {
    const s = String(issue || '').toLowerCase();
    return s.includes(lower) || s.includes(pretty);
  });
};

export function formatName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  if (trimmed.includes(',')) {
    const [last, first] = trimmed.split(',').map((s) => s.trim());
    if (first && last) return `${first} ${last}`;
  }
  return trimmed;
}
